import { connectRouter, RouterState } from 'connected-react-router';
import { History } from 'history';
import { AnyAction, combineReducers } from 'redux';
import { isType } from 'typescript-fsa';

import { initializeStore } from '../actions/common';
import assessmentResult, { IAssessmentResultState } from './assessmentResult';
import common, { ICommonState } from './common';
import eLearning, { IELearningState } from './eLearning';
import exercise, { IExerciseState } from './exercise';
import exerciseForm, { IExerciseFormState } from './exerciseForm';
import help, { IHelpState } from './help';
import imstat, { IImstatState } from './imstat';
import indicator, { IIndicatorState } from './indicator';
import login, { ILoginState } from './login';
import loginSso, { ILoginSsoState } from './loginSso';
import mainMenu, { IMainMenuState } from './mainMenu';
import message, { IMessageState } from './message';
import messageDetail, { IMessageDetailState } from './MessageDetail';
import navbar, { INavbarState } from './navbar';
import portal, { IPortalState } from './portal';
import profile, { IProfileState } from './profile';
import questionnaire, { IQuestionnaireState } from './questionnaire';
import questionnaireList, {
	IQuestionnaireListState,
} from './QuestionnaireList';
import quickModeContents, {
	IQuickModeContentsState,
} from './quickModeContents';
import searchLogFileState, {
	ISearchLogFileState,
} from './quickModeOrgUserRegisterLogFileObj';
import quickModeOrgUserRegisterTreeObj, {
	ISearchOrgUserListState,
} from './quickModeOrgUserRegisterTreeObj';
import studentAssignState, {
	IStudentAssignState,
} from './quickModeStudentAssign';
import scorm, { IScormState } from './scorm';
import search, { ISearchState } from './search';
import session, { ISessionState } from './session';
import skill, { ISkillState } from './skill';
import skillDetail, { ISkillDetailState } from './skillDetail';
import skillMap, { ISkillMapState } from './skillMap';
import skillMapDetail, { ISkillMapDetailState } from './skillMapDetail';
import testForm, { ITestFormState } from './testForm';
import testResult, { ITestResultState } from './testResult';
import user, { IUserState } from './user';
import whatsNewDetail, { IWhatsNewDetailState } from './WhatsNewDetail';

/**
 * ルートストア
 */
export interface IRootState {
	assessmentResult: IAssessmentResultState;
	common: ICommonState;
	login: ILoginState;
	loginSso: ILoginSsoState;
	mainMenu: IMainMenuState;
	message: IMessageState;
	messageDetail: IMessageDetailState;
	session: ISessionState;
	navbar: INavbarState;
	portal: IPortalState;
	search: ISearchState;
	profile: IProfileState;
	eLearning: IELearningState;
	help: IHelpState;
	imstat: IImstatState;
	indicator: IIndicatorState;
	testForm: ITestFormState;
	testResult: ITestResultState;
	questionnaire: IQuestionnaireState;
	router: RouterState;
	exercise: IExerciseState;
	exerciseForm: IExerciseFormState;
	user: IUserState;
	whatsNewDetail: IWhatsNewDetailState;
	scorm: IScormState;
	skillMap: ISkillMapState;
	questionnaireList: IQuestionnaireListState;
	skill: ISkillState;
	skillDetail: ISkillDetailState;
	skillMapDetail: ISkillMapDetailState;
	quickModeContents: IQuickModeContentsState;
	studentAssignState: IStudentAssignState;
	quickModeOrgUserRegisterTreeObj: ISearchOrgUserListState;
	searchLogFileState: ISearchLogFileState;
}

/**
 * ルートレデューサ
 */
export default (history: History) => (state: IRootState, action: AnyAction) => {
	const reducer = combineReducers({
		assessmentResult,
		common,
		eLearning,
		exercise,
		exerciseForm,
		help,
		imstat,
		indicator,
		login,
		loginSso,
		mainMenu,
		message,
		messageDetail,
		navbar,
		portal,
		profile,
		questionnaire,
		questionnaireList,
		quickModeContents,
		quickModeOrgUserRegisterTreeObj,
		router: connectRouter(history),
		scorm,
		search,
		searchLogFileState,
		session,
		skill,
		skillDetail,
		skillMap,
		skillMapDetail,
		studentAssignState,
		testForm,
		testResult,
		user,
		whatsNewDetail,
	});

	if (isType(action, initializeStore)) {
		return reducer(undefined, action);
	}

	return reducer(state, action);
};



// WEBPACK FOOTER //
// ./src/reducers/index.ts